import React, { useContext, useEffect, useState } from "react";
import { IoIosStar } from "react-icons/io";
import { AiOutlineCaretDown, AiFillCaretUp } from "react-icons/ai";
import ParameterContext from "../context/parameter/parameterContext";
import CryptoContext from "../context/crypto/cryptoContext";
import AuthContext from "../context/auth/authContext";
import NumberFormat from "react-number-format";
import getSymbolFromCurrency from "currency-symbol-map";
import HomeChart from "../components/HomeChart";
import { Link } from "react-router-dom";
import Price from "../components/Price";
import { formatNumber } from "../helpers/format";
import ReactTooltip from "react-tooltip";

const Favourite = ({ history, location }) => {
  const { favouriteCoins, addFavouriteCoin, userData, favouriteLoading } =
    useContext(AuthContext);
  const { setColumnName, columnName, setFavouriteTab, favouriteTab } =
    useContext(ParameterContext);
  const {
    cryptoData,
    convt,
    sortGlobalTickerByPrice,
    order,
    sortGlobalTickerBy24h,
    sortGlobalTickerByRank,
    sortGlobalTickerBy7d,
    sortGlobalTickerByName,
    sortGlobalTickerByMarketCap,
    sortGlobalTickerByVolumeIn24h,
    loading,
    getFavouriteCryptoCoins,
    favouriteCryptoCoins,
    exchangeRate,
    sparklineData,
  } = useContext(CryptoContext);
  const currencySymbol = getSymbolFromCurrency(convt);
  const [favourite, setFavourite] = useState(null);
  useEffect(() => {
    setColumnName(null);
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (
      userData &&
      favouriteCoins &&
      favouriteCoins.length > 0 &&
      cryptoData &&
      cryptoData.length > 0
    ) {
      getFavouriteCryptoCoins(favouriteCoins);
    }

    //eslint-disable-next-line
  }, [history, favouriteCoins, userData, cryptoData]);
  // useEffect(() => {

  //   // setColumnName("");
  //   // setTimeout(()=>getNamesOfDisplayedCryptoData(),2000) shifted to appbar page
  //   if (favouriteCoins) {
  //     if (!favouriteSparklineData || !favouriteSparklineData.length > 0)
  //       setTimeout(() => getSparklinesofFavourite(favouriteCoins.join(","), "7d"), 3500);
  //   }
  //   // if (columnName === "") {
  //   //   getGlobalTicker(page + 1, localCurrency);
  //   // }
  //   //eslint-disable-next-line
  // }, [
  //   favouriteCoins
  // ]);
  const handleClick = (id) => {
    history.push(`/cryptos/${id}`);
  };
  const handleFavouriteClick = (id) => {
    setFavourite(id);
    addFavouriteCoin(id);
  };
  const data = favouriteCryptoCoins;
  return (
    <>
      <div className="Home">
        <div className="Home__container">
          <div className="Favourite__TableHeader">
            <h2>Favourite</h2>
            <div className="Favourite__tabs">
              <button
                className={
                  favouriteTab === "coins"
                    ? "Favourite__exchange-tab"
                    : "Favourite__portfolio-tab"
                }
                onClick={() => setFavouriteTab("coins")}
              >
                Coins
              </button>
              {/* <button
                className={
                  favouriteTab === "portfolio"
                    ? "Favourite__exchange-tab"
                    : "Favourite__portfolio-tab"
                }
                onClick={() => setFavouriteTab("portfolio")}
              >
                Portfolio
              </button> */}
            </div>
          </div>
          {/*Table*/}
          {favouriteTab === "coins" ? (
            favouriteCoins &&
            favouriteCoins.length > 0 &&
            data &&
            data.length > 0 ? (
              <div
                className="Home__tableContainer"
                style={{ minHeight: "300px" }}
              >
                <table className="Home__MainTable">
                  <thead>
                    <tr>
                      <th></th>
                      <th style={{ textAlign: "left" }}>
                        <div className="Home__MainTable-th">
                          <div
                            style={{
                              color: "white",
                            }}
                            className="Home__MainTable__pct"
                          >
                            {columnName &&
                            columnName === "rank" &&
                            order === 1 ? (
                              <AiFillCaretUp className="Home__MainTable__pcticon" />
                            ) : columnName &&
                              columnName === "rank" &&
                              order === 0 ? (
                              <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                            ) : (
                              <></>
                            )}
                            &nbsp;
                            <div
                              onClick={() => {
                                sortGlobalTickerByRank(2);
                                setColumnName("rank");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              Rank
                            </div>
                          </div>
                        </div>
                      </th>
                      <th style={{ textAlign: "left" }}>
                        <div className="Home__MainTable-th">
                          <div
                            style={{
                              color: "white",
                            }}
                            className="Home__MainTable__pct"
                          >
                            {columnName &&
                            columnName === "name" &&
                            order === 1 ? (
                              <AiFillCaretUp className="Home__MainTable__pcticon" />
                            ) : columnName &&
                              columnName === "name" &&
                              order === 0 ? (
                              <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                            ) : (
                              <></>
                            )}
                            &nbsp;
                            <div
                              onClick={() => {
                                sortGlobalTickerByName(2);
                                setColumnName("name");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              Name
                            </div>
                          </div>
                        </div>
                      </th>
                      <th style={{ textAlign: "right" }}>
                        <div
                          className="Home__MainTable-th"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <div
                            style={{
                              color: "white",
                            }}
                            className="Home__MainTable__pct"
                          >
                            {columnName &&
                            columnName === "price" &&
                            order === 1 ? (
                              <AiFillCaretUp className="Home__MainTable__pcticon" />
                            ) : columnName &&
                              columnName === "price" &&
                              order === 0 ? (
                              <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                            ) : (
                              <></>
                            )}
                            &nbsp;
                            <div
                              onClick={() => {
                                sortGlobalTickerByPrice(2);
                                setColumnName("price");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              Price
                            </div>
                          </div>
                        </div>
                      </th>
                      <th style={{ textAlign: "right" }}>
                        <div
                          className="Home__MainTable-th"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <div
                            style={{
                              color: "white",
                            }}
                            className="Home__MainTable__pct"
                          >
                            {columnName &&
                            columnName === "24h%" &&
                            order === 1 ? (
                              <AiFillCaretUp className="Home__MainTable__pcticon" />
                            ) : columnName &&
                              columnName === "24h%" &&
                              order === 0 ? (
                              <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                            ) : (
                              <></>
                            )}
                            &nbsp;
                            <div
                              onClick={() => {
                                sortGlobalTickerBy24h(2);
                                setColumnName("24h%");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              24h %
                            </div>
                          </div>
                        </div>
                      </th>
                      <th style={{ textAlign: "right" }}>
                        <div
                          className="Home__MainTable-th"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <div
                            style={{
                              color: "white",
                            }}
                            className="Home__MainTable__pct"
                          >
                            {columnName &&
                            columnName === "7d%" &&
                            order === 1 ? (
                              <AiFillCaretUp className="Home__MainTable__pcticon" />
                            ) : columnName &&
                              columnName === "7d%" &&
                              order === 0 ? (
                              <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                            ) : (
                              <></>
                            )}
                            &nbsp;
                            <div
                              onClick={() => {
                                sortGlobalTickerBy7d(2);
                                setColumnName("7d%");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              7d%
                            </div>
                          </div>
                        </div>
                      </th>
                      <th style={{ textAlign: "right" }}>
                        <div
                          className="Home__MainTable-th"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <div
                            style={{
                              color: "white",
                            }}
                            className="Home__MainTable__pct"
                          >
                            {columnName &&
                            columnName === "marketcap" &&
                            order === 1 ? (
                              <AiFillCaretUp className="Home__MainTable__pcticon" />
                            ) : columnName &&
                              columnName === "marketcap" &&
                              order === 0 ? (
                              <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                            ) : (
                              <></>
                            )}
                            &nbsp;
                            <div
                              onClick={() => {
                                sortGlobalTickerByMarketCap(2);
                                setColumnName("marketcap");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              Market Cap
                            </div>
                          </div>
                        </div>
                      </th>
                      <th style={{ textAlign: "right" }}>
                        <div
                          className="Home__MainTable-th"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <div
                            style={{
                              color: "white",
                            }}
                            className="Home__MainTable__pct"
                          >
                            {columnName &&
                            columnName === "volumeIn24h" &&
                            order === 1 ? (
                              <AiFillCaretUp className="Home__MainTable__pcticon" />
                            ) : columnName &&
                              columnName === "volumeIn24h" &&
                              order === 0 ? (
                              <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                            ) : (
                              <></>
                            )}
                            &nbsp;
                            <div
                              onClick={() => {
                                sortGlobalTickerByVolumeIn24h(2);
                                setColumnName("volumeIn24h");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              Volume(24h)
                            </div>
                          </div>
                        </div>
                      </th>
                      <th style={{ textAlign: "right", paddingRight: "20px" }}>
                        <div
                          className="Home__MainTable-th"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <div>
                            <p>Last 7 days</p>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {favouriteCryptoCoins &&
                    favouriteCryptoCoins.length > 0 &&
                    typeof favouriteCryptoCoins[0] !== "undefined" ? (
                      favouriteCryptoCoins.map((c, index) => (
                        <>
                          <tr key={c.rank} className="Home__MainTable__link">
                            <td style={{ textAlign: "left" }}>
                              <div className="Home__MainTable-td">
                                <div>
                                  <ReactTooltip place="bottom" effect="float" />
                                  {favouriteLoading && c.id === favourite ? (
                                    <div
                                      className="loader1"
                                      style={{
                                        height: "15px",
                                        width: "15px",
                                        display: "inline-block",
                                        border: "3px solid #f3f3f3",
                                        borderTop: "3px solid #8d0792",
                                        marginLeft: "5px",
                                      }}
                                    ></div>
                                  ) : (
                                    <IoIosStar
                                      data-tip="Remove from Watchlist"
                                      size={24}
                                      style={{
                                        marginRight: "4px",
                                        paddingTop: "5px",
                                        cursor: "pointer",
                                        color: "rgba(141, 7, 146, 1)",
                                        outline: "none",
                                      }}
                                      onClick={() => handleFavouriteClick(c.id)}
                                    />
                                  )}
                                </div>
                              </div>
                            </td>
                            {loading ? (
                              <td style={{ textAlign: "left" }}>
                                <div className="Home__MainTable-td">
                                  <div className="skeleton text" />
                                </div>
                              </td>
                            ) : (
                              <Price
                                id={c.id}
                                item={c.rank}
                                property="rank"
                                style1={{ textAlign: "left" }}
                              />
                            )}

                            {loading ? (
                              <td style={{ textAlign: "left", width: "300px" }}>
                                <div
                                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <div
                                    className="skeleton avatar"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      marginRight: "5px",
                                    }}
                                  />
                                  <div
                                    className="skeleton text"
                                    style={{ width: "50px" }}
                                  />
                                  <div
                                    className="skeleton text"
                                    style={{ width: "120px" }}
                                  />
                                  <div
                                    className="skeleton text"
                                    style={{ width: "60px" }}
                                  />
                                  <div className="shimmer-wrapper">
                                    <div className="shimmer"></div>
                                  </div>
                                </div>
                              </td>
                            ) : (
                              <td
                                style={{ textAlign: "left", maxWidth: "340px" }}
                              >
                                <div className="Home__MainTable-td">
                                  <img
                                    src={c.logo_url}
                                    alt="bitcoin"
                                    style={{
                                      width: "25px",
                                      height: "25px",
                                      marginRight: "5px",
                                    }}
                                  />
                                  <p
                                    style={{
                                      marginRight: "5px",

                                      cursor: "pointer",
                                      whiteSpace: "normal",
                                    }}
                                    onClick={() => handleClick(c.id)}
                                  >
                                    {c.name}
                                  </p>
                                  <p
                                    style={{
                                      color: "#A8A8A8",
                                      marginRight: "5px",
                                    }}
                                  >
                                    {c.id}
                                  </p>
                                </div>
                              </td>
                            )}

                            {loading ? (
                              <td style={{ textAlign: "left" }}>
                                <div
                                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                  style={{
                                    textAlign: "left",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <div
                                    className="skeleton text"
                                    style={{ width: "100px" }}
                                  />
                                  <div className="shimmer-wrapper">
                                    <div className="shimmer"></div>
                                  </div>
                                </div>
                              </td>
                            ) : c.price ? (
                              <Price
                                id={c.id}
                                item={Number(c.price) / exchangeRate}
                                property="price"
                                style2={{
                                  justifyContent: "flex-end",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                                style1={{ textAlign: "right" }}
                              />
                            ) : (
                              <td style={{ textAlign: "right" }}>
                                <div
                                  className="Home__MainTable-td"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  <div className="Home__MainTable__pct">NA</div>
                                </div>
                              </td>
                            )}
                            {loading ? (
                              <td style={{ textAlign: "left" }}>
                                <div
                                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                  style={{
                                    textAlign: "left",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <div
                                    className="skeleton text"
                                    style={{ width: "60px" }}
                                  />
                                  <div className="shimmer-wrapper">
                                    <div className="shimmer"></div>
                                  </div>
                                </div>
                              </td>
                            ) : c["1d"]?.price_change_pct ? (
                              <td style={{ textAlign: "right" }}>
                                <div
                                  className="Home__MainTable-td"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  <div
                                    style={{
                                      color:
                                        (c["1d"]?.price_change_pct
                                          ? Number(c["1d"]?.price_change_pct)
                                          : "") > 0
                                          ? "rgba(69, 170, 67, 1)"
                                          : "rgba(233, 56, 72, 1)",
                                    }}
                                    className="Home__MainTable__pct"
                                  >
                                    {Number(c["1d"]?.price_change_pct) > 0 ? (
                                      <AiFillCaretUp className="Home__MainTable__pcticon" />
                                    ) : (
                                      <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                                    )}
                                    &nbsp;
                                    <div>
                                      {Math.abs(
                                        Number(c["1d"]?.price_change_pct) * 100
                                      ).toFixed(2) + "%"}
                                    </div>
                                  </div>
                                </div>
                              </td>
                            ) : (
                              <td style={{ textAlign: "right" }}>
                                <div
                                  className="Home__MainTable-td"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  <div className="Home__MainTable__pct">NA</div>
                                </div>
                              </td>
                            )}

                            {loading ? (
                              <td style={{ textAlign: "left" }}>
                                <div
                                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                  style={{
                                    textAlign: "left",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <div
                                    className="skeleton text"
                                    style={{ width: "60px" }}
                                  />
                                  <div className="shimmer-wrapper">
                                    <div className="shimmer"></div>
                                  </div>
                                </div>
                              </td>
                            ) : c["7d"]?.price_change_pct ? (
                              <td style={{ textAlign: "right" }}>
                                <div
                                  className="Home__MainTable-td"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  <div
                                    style={{
                                      color:
                                        Number(c["7d"]?.price_change_pct) > 0
                                          ? "rgba(69, 170, 67, 1)"
                                          : "rgba(233, 56, 72, 1)",
                                    }}
                                    className="Home__MainTable__pct"
                                  >
                                    {Number(c["7d"]?.price_change_pct) > 0 ? (
                                      <AiFillCaretUp className="Home__MainTable__pcticon" />
                                    ) : (
                                      <AiOutlineCaretDown />
                                    )}
                                    &nbsp;
                                    <div>
                                      {Math.abs(
                                        Number(c["7d"]?.price_change_pct) * 100
                                      ).toFixed(2) + "%"}
                                    </div>
                                  </div>
                                </div>
                              </td>
                            ) : (
                              <td style={{ textAlign: "right" }}>
                                <div
                                  className="Home__MainTable-td"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  <div className="Home__MainTable__pct">NA</div>
                                </div>
                              </td>
                            )}

                            {loading ? (
                              <td style={{ textAlign: "left" }}>
                                <div
                                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                  style={{
                                    alignItems: "flex-end",
                                    flexDirection: "column",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    className="skeleton text"
                                    style={{ width: "100px" }}
                                  />
                                  <div
                                    className="skeleton text"
                                    style={{ width: "60px" }}
                                  />
                                  <div className="shimmer-wrapper">
                                    <div className="shimmer"></div>
                                  </div>
                                </div>
                              </td>
                            ) : c.market_cap ? (
                              <td style={{ textAlign: "right" }}>
                                <div
                                  className="Home__MainTable-td"
                                  style={{
                                    alignItems: "flex-end",
                                    flexDirection: "column",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleClick(c.id)}
                                >
                                  <div>
                                    <NumberFormat
                                      value={
                                        Number(c.market_cap) / exchangeRate
                                      }
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={`${currencySymbol} `}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      color: "#717171",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {currencySymbol}
                                    {formatNumber(
                                      Number(c.market_cap) / exchangeRate
                                    )}
                                  </div>
                                </div>
                              </td>
                            ) : (
                              <td style={{ textAlign: "right" }}>
                                <div
                                  className="Home__MainTable-td"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  <div className="Home__MainTable__pct">NA</div>
                                </div>
                              </td>
                            )}

                            {loading ? (
                              <td style={{ textAlign: "left" }}>
                                <div
                                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                  style={{
                                    alignItems: "flex-end",
                                    flexDirection: "column",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    className="skeleton text"
                                    style={{ width: "100px" }}
                                  />
                                  <div
                                    className="skeleton text"
                                    style={{ width: "60px" }}
                                  />
                                  <div className="shimmer-wrapper">
                                    <div className="shimmer"></div>
                                  </div>
                                </div>
                              </td>
                            ) : c["1d"]?.volume ? (
                              <Price
                                property="1dVolume"
                                id={c.id}
                                item1={Number(c["1d"]?.volume) / exchangeRate}
                                item={Number(c.price) / exchangeRate}
                                style2={{
                                  alignItems: "flex-end",
                                  flexDirection: "column",

                                  // whiteSpace: "nowrap",
                                }}
                                style1={{ textAlign: "right" }}
                                style3={{ color: "#717171", fontSize: "14px" }}
                              />
                            ) : (
                              <td style={{ textAlign: "right" }}>
                                <div
                                  className="Home__MainTable-td"
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  <div className="Home__MainTable__pct">NA</div>
                                </div>
                              </td>
                            )}
                            <td
                              style={{ paddingLeft: "20px", cursor: "pointer" }}
                            >
                              {loading || !sparklineData ? (
                                <div
                                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                  style={{
                                    alignItems: "flex-end",
                                    flexDirection: "column",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    className="skeleton text"
                                    style={{ width: "130px", height: "40px" }}
                                  />
                                </div>
                              ) : (
                                <Link to={`/cryptos/${c.id}`}>
                                  <HomeChart
                                    symbol={c.id}
                                    time={index}
                                    data={
                                      sparklineData.filter(
                                        (i, index) => i.currency === c.id
                                      )[0]
                                        ? sparklineData.filter(
                                            (i, index) => i.currency === c.id
                                          )[0].prices
                                          ? sparklineData.filter(
                                              (i, index) => i.currency === c.id
                                            )[0].prices
                                          : []
                                        : []
                                    }
                                    color={
                                      Number(c["7d"]?.price_change_pct) > 0
                                        ? "rgba(69, 170, 67, 1)"
                                        : "rgba(233, 56, 72, 1)"
                                    }
                                  />
                                </Link>
                              )}
                              {/*</span>  <span className="Home__MainTable__row-name"> */}
                            </td>
                          </tr>
                        </>
                      ))
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <center style={{ marginBottom: "300px" }}>
                <p>Please add coins to favourite</p>
              </center>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default Favourite;
